import DialChart from "../molecules/DialChart";
import AiAnalysisResult from "./AiAnalysisResult";
import RelatedKeyword from "./RelatedKeyword";
import DegreeSection from "./DegreeSection";
import MeasurementResult from "./MeasurementResult";

export default function DetailSkinGlow({data, img, isJuniorUser}) {
    const degreeArr = [
        {
            value: "비교적 나쁨", 
            level: 4
        },
        {
            value: "일반", 
            level: 3
        },
        {
            value: "좋음", 
            level: 2
        },
        {
            value: "최고", 
            level: 1
        },
    ];

    return (
        <MeasurementResult type="광채" 
                            description="피부 광채는 피부가 빛을 반사하는 정도, 텍스처, 톤 균일도를 관찰해 평가합니다. 빛 반사는 피부 표면의 반사율을, 텍스처는 피부의 거칠기를, 톤 균일도는 표피 아래 피부층이 빛을 흡수하고 반사하는 능력을 나타냅니다."
                            score={data.score}
        >
            <div className="row-wrap">
                <div className="img-wrap more">
                    <div className="img-cont">
                        <img src={img.image_cross_polar_front} />
                        {!isJuniorUser && <img src={img.image_mark_oil_front} />}
                        <div className="caption">평행편광</div>
                    </div>
                    <div className="img-cont">
                        <img src={img.image_cross_polar_front} />
                        {!isJuniorUser && <img src={img.image_mark_skin_texture_front} />}
                        <div className="caption">평행편광</div>
                    </div>
                    <div className="img-cont">
                        <img src={img.image_homo_front} />
                        <div className="caption">균일한 피부톤</div>
                    </div>
                </div>

                <DegreeSection type="광채" 
                    items={[
                        {
                            value: "비교적 나쁨", 
                        },
                        {
                            value: "일반", 
                        },
                        {
                            value: "좋음", 
                        },
                        {
                            value: "최고", 
                        },
                    ]} 
                    level={data.level}
                    text={data.degreeText}
                    reverse={true}
                    badge={data.analysisBadge}
                    line={3}
                />
            </div>

            <div className="row-wrap">
                <section>
                    <div className="h4">광채에 원인을 주는 3가지 요인</div>

                    <div className="row-wrap">
                        <section className="flex-content-center direction-row">
                            <div className="h4 d-flex direction-column">
                                유분
                                <div className={data.skinReflection.type == "1" ? "report-badge body3 yellow"  : "report-badge body3 blue"}>{data.skinReflection.typeName}</div>
                            </div>

                            <DialChart color={data.skinReflection.type == "1" ? "yellow" : "blue"} value={data.skinReflection.scoreOil} />
                        </section>

                        <section className="flex-content-center">
                            <div className="h4">피부 텍스처</div>

                            <div className="h1">
                                {
                                    data.skinHomogenity.level == 1 && "미세"
                                }
                                {
                                    data.skinHomogenity.level == 2 && "비교적 쫀쫀"
                                }
                                {
                                    data.skinHomogenity.level == 3 && "약간 거침"
                                }
                                {
                                    data.skinHomogenity.level == 4 && "거침"
                                }
                            </div>
                        </section>
                    </div>

                    <div className="row-wrap">
                        <section className="flex-content-center direction-row">
                            <div className="d-flex text-nowrap h4 direction-column justify-content-between">
                                피부톤 균일도
                                <div className="report-badge body3">
                                    {degreeArr.find(item => item.level === data.skinHomogenity.level).value}
                                </div>
                            </div>

                            <div className="ribbon-graph level has-tooltip">
                                {
                                    degreeArr.map(el => {
                                        return (
                                            <div key={el.value} className={el.level >= data.skinHomogenity.level ? "fill" : ""}>
                                                {el.value}
                                                {
                                                    el.level == data.skinHomogenity.level &&
                                                    <div className="tooltip">
                                                        <span>현재 단계</span>
                                                    </div>
                                                }
                                            </div>
                                        )
                                    })
                                }
                            </div>
                        </section>
                    </div>
                </section>
            </div>

            <div className="row-wrap grow">
                <RelatedKeyword list={data.keyword} />

                
                <AiAnalysisResult 
                    height={237}
                    text={data.aiResult} 
                /> 
            </div>
        </MeasurementResult>
    )
}